import { IonApp } from '@ionic/react';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import { withAuthenticator } from 'aws-amplify-react';
import '@aws-amplify/ui/dist/style.css';
import Routes from './Routes';
import './theme/variables.css'
import './components/Menu/Menu.css'

// Amplify.configure({
//   Auth: {
//     identityPoolId: "us-east-1:06a9363e-f104-4569-9885-17a9b84d96f9",
//     region: "us-east-1",
//     userPoolId: "us-east-1_HzKBtNQLP",
//     userPoolWebClientId: "ra5lqnh7cvcgnlfpk7m64jaj8",
//     RoleArn: "arn:aws:cognito-idp:us-east-1:162838978339:userpool/us-east-1_HzKBtNQLP"
//   }
// })

Amplify.configure({
  Auth: {
    identityPoolId: "us-east-1:95e1ee34-ef10-4d9f-95c8-ff1178aaeadf",
    region: "us-east-1",
    userPoolId: "us-east-1_y5NaS8A3z",
    userPoolWebClientId:"2htdqgdj11mlui0npj3uf0aqnr",
    RoleArn: "arn:aws:cognito-idp:us-east-1:250891455252:userpool/us-east-1_y5NaS8A3z"
  }
})

const App: React.FC = () => {
  return (
    <IonApp>
      <Routes/>
    </IonApp>
  );
};

export default App;
